import { render, staticRenderFns } from "./InvoiceId.vue?vue&type=template&id=a3beda64&scoped=true&"
import script from "./InvoiceId.vue?vue&type=script&lang=js&"
export * from "./InvoiceId.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceId.vue?vue&type=style&index=0&id=a3beda64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3beda64",
  null
  
)

export default component.exports